<template>
    <div class="container">
        <section class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Settings</div>
                    </div>
                </div>
            </div>
            <div class="section__content">
                <ul class="nav nav-tabs d-none d-lg-flex justify-content-start nav-tabs" role="tablist">
                    <li class="nav-item">
                        <button @click="$router.push('/settings/profile')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Profile</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/preferences')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Preferences</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/verification')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Verification</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/security')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Security</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/payment-methods')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Payment methods</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/apps')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Apps</span></div>
                        </button>
                    </li>
                    <li class="nav-item nav-item--active">
                        <button @click="$router.push('/settings/limits')" class="btn btn--tertiary btn--block nav-link nav-link--active rounded-0 m-auto"
                                type="button" data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="true">
                            <div class="nav-link__tab"><span class="nav-link__label">Limits</span></div>
                        </button>
                    </li>
                </ul>
                <div class="dropdown d-block d-lg-none tabs-dropdown">
                    <div class="dropdown-toggle d-block w-100 py-1" id="settings-toggle" aria-haspopup="true"
                         aria-expanded="false"><h4 class="m-0">Limits</h4></div>
                </div>
                <hr class="d-block d-lg-none mt-0">
                <div class="d-flex flex-column flex-lg-row">
                    <div class="d-flex flex-column col-lg-6 mb-6 mb-lg-0">
                        <h4><span>Your current monthly volume</span>
                            <button class="btn--icon btn--icon--24 btn--icon--secondary border-0" type="button">
                                <svg viewBox="0 0 24 24" class="icon">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM11 8C11 7.44772 11.4477 7 12 7H12.01C12.5623 7 13.01 7.44772 13.01 8C13.01 8.55228 12.5623 9 12.01 9H12C11.4477 9 11 8.55228 11 8ZM12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z"></path>
                                </svg>
                            </button>
                        </h4>
                        <p>The following is the current volume you’ve transacted in AIRTM this month, be mindful of the
                            limits you have due to your verification level and account type. </p><h4 class="mb-0">$0,00
                        USDC</h4></div>
                    <div class="d-flex flex-column col-lg-6"><h4>Your current lifetime volume</h4>
                        <p>The following is the current volume you’ve transacted in AIRTM, be mindful of the limits you
                            have due to your verification level and account type.</p><h4 class="mb-0">$0,00 USDC</h4>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "limits",
    }
</script>

<style scoped>

</style>